import desktopLeftImage from './assets/desktop-left-side-image.svg'
import desktopRightImage from './assets/desktop-right-side-image.svg'
import mobileTopImage from './assets/mobile-top-side-image.svg'

/**
 * Styles specific to the Shopify integration banner
 * Uses SVG assets for background and feature cards
 */
export const stylesShopify = {
  container: {
    maxWidth: 1000,
    borderRadius: 8,
    backgroundColor: '#FFF',
    position: 'relative',
    marginBottom: 20,
    height: 128,
    overflow: 'hidden',
    '@media screen and (max-width: 768px)': {
      padding: '140px 20px 24px 20px',
      minHeight: 'fit-content',
    },
    // Desktop left side background (cards)
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      top: '0',
      width: 361,
      height: '100%',
      backgroundImage: `url(${desktopLeftImage})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left center',
      '@media screen and (max-width: 768px)': {
        top: 0,
        left: 0,
        transform: 'none',
        width: '100%',
        height: 144,
        backgroundImage: `url(${mobileTopImage})`,
        backgroundPosition: 'left top',
        backgroundSize: 'cover',
      },
    },
    // Desktop right side background (blob)
    '&::after': {
      content: '""',
      position: 'absolute',
      right: -50,
      top: '0',
      width: 204,
      height: '100%',
      backgroundImage: `url(${desktopRightImage})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right center',
      '@media screen and (max-width: 768px)': {
        display: 'none',
      },
    },
  },

  contentWrapper: {
    position: 'relative',
    padding: '0 40px',
    cursor: 'pointer',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 20,
    },
  },

  // Text content section
  textContainer: {
    flex: '1 1 auto',
    maxWidth: 400,
    marginLeft: 'auto',
    '@media screen and (max-width: 768px)': {
      maxWidth: '100%',
      textAlign: 'left',
      margin: 0,
    },
  },

  title: {
    fontWeight: 700,
    fontSize: 28,
    lineHeight: '30px',
    color: '#011533',
    marginBottom: 4,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    '& .shopifyLogo': {
      display: 'inline-flex',
      verticalAlign: 'middle',
      marginTop: -2,
    },
    '@media screen and (max-width: 768px)': {
      justifyContent: 'flex-start',
      gap: 4,
    },
  },

  description: {
    fontSize: 14,
    lineHeight: '20px',
    color: '#2D264B',
  },

  // Button section
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    '@media screen and (max-width: 768px)': {
      width: '100%',
      justifyContent: 'flex-start',
    },
  },

  button: {
    height: 48,
    width: 198,
    background: '#004360',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 12,
    padding: '14px 20px',
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    transition: 'all 0.2s ease',
    whiteSpace: 'nowrap',
    '&:hover': {
      background: '#D63850',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(238, 67, 96, 0.3)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    '& svg': {
      flexShrink: 0,
    },
    '@media screen and (max-width: 768px)': {
      width: 188,
      height: 40,
      justifyContent: 'center',
      padding: '14px 20px',
    },
  },

  // Close button
  closeBtn: {
    border: 'none',
    position: 'absolute',
    top: 12,
    right: 12,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    zIndex: 2,
  },

  crossMark: {
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.7,
    },
  },
}
